import { SearchResultType } from "../domain/Profiles";
export function getIndicesOf(searchStr, str, caseSensitive) {
    var tempStr = str;
    var tempSearchStr = searchStr;
    var searchStrLen = tempSearchStr.length;
    if (searchStrLen === 0) {
        return [];
    }
    var startIndex = 0;
    var index;
    var indices = [];
    if (!caseSensitive) {
        tempStr = tempStr.toLowerCase();
        tempSearchStr = tempSearchStr.toLowerCase();
    }
    while ((index = tempStr.indexOf(tempSearchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
}
export function getEntityRanges(text, mentionName, mentionKey) {
    var indices = getIndicesOf(mentionName, text);
    if (indices.length > 0) {
        return indices.map(function (offset) { return ({
            key: mentionKey,
            length: mentionName.length,
            offset: offset
        }); });
    }
    return null;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function makeMentionSearchResults(mentionSearchResults) {
    return mentionSearchResults.map(function (p) {
        if (p.type === SearchResultType.userprofile) {
            return {
                name: "[@profile|".concat(p.id, "]"),
                id: p.id,
                displayName: p.displayName,
                avatarUrl: p.avatarUrl,
                type: p.type,
                jobRole: p.jobRole,
                departmentName: p.departmentName
            };
        }
        else {
            return {
                name: "[@".concat(p.type, "|").concat(p.id, "]"),
                id: p.id,
                displayName: p.displayName,
                avatarUrl: p.avatarUrl,
                type: p.type
            };
        }
    });
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function makeHashtagSearchResults(hashTagsSearchResults) {
    return hashTagsSearchResults.map(function (h) {
        return {
            name: "#".concat(h.displayName),
            id: h.id,
            displayName: "#".concat(h.displayName),
            postsCount: h.type === SearchResultType.tag ? h.postsCount : 0
        };
    });
}
//# sourceMappingURL=data:application/json;base64,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